import { cleanQuestionText } from './textHelpers';

export const WRITING_SCORING_SCOPE = {
  FULL_WRITING: 'full_writing',
  SINGLE_TASK_PRACTICE: 'single_task_practice',
};

const resolveOriginalSectionIndex = (selectedSectionIndices, localIndex) => {
  const originalIndex = selectedSectionIndices?.[localIndex];
  return Number.isInteger(originalIndex) ? originalIndex : localIndex;
};

export const getWritingScoringScope = ({ mode, sections = [], selectedSectionIndices }) => {
  const selectedTasks = sections
    .map((_, localIndex) => resolveOriginalSectionIndex(selectedSectionIndices, localIndex) + 1)
    .filter((taskNumber) => taskNumber === 1 || taskNumber === 2);

  return mode === 'practice' && selectedTasks.length === 1
    ? WRITING_SCORING_SCOPE.SINGLE_TASK_PRACTICE
    : WRITING_SCORING_SCOPE.FULL_WRITING;
};

export const buildWritingSubmitPayload = ({
  sections = [],
  selectedSectionIndices,
  answers = [],
  testStartTime,
  endTime,
  testType,
  mode = 'practice',
  groupId,
  fullTestAttemptId,
  isSpeakingOptional = false,
}) => {
  const firstSection = sections[0] || {};
  const selectedWritingTasks = [];
  const payload = {
    testId: firstSection.test_id || firstSection.testId || 1,
    test_type: testType || firstSection.test_type || firstSection.test?.test_type || 'Academic',
    start_time: testStartTime,
    end_time: endTime,
    scoring_scope: getWritingScoringScope({ mode, sections, selectedSectionIndices }),
  };

  if (groupId) {
    payload.groupId = groupId;
    payload.is_speaking_optional = isSpeakingOptional;
  }

  if (groupId && fullTestAttemptId) {
    payload.fullTestAttemptId = fullTestAttemptId;
  }

  sections.forEach((section, localIndex) => {
    const originalIndex = resolveOriginalSectionIndex(selectedSectionIndices, localIndex);
    const taskNumber = originalIndex + 1;

    if (taskNumber !== 1 && taskNumber !== 2) {
      return;
    }

    const questionId = section.questions && section.questions.length > 0
      ? section.questions[0].id
      : null;
    const key = taskNumber === 1 ? 'part1' : 'part2';

    selectedWritingTasks.push(taskNumber);
    payload[key] = {
      partId: section.id,
      questionId,
      userAnswer: answers[localIndex] || '',
      questionText: cleanQuestionText(section.passage_text || ''),
    };
  });

  payload.selected_writing_tasks = [...new Set(selectedWritingTasks)].sort();

  return payload;
};
